export type AcceptOrderTranslations = {
  summary: string;
  areYouSureTradeCancel: string;
  noDontCancel: string;
  yesGoToPortfolio: string;
  targetPrice: string;
  showLimitOrderTerms: string;
  buyAmount: string;
  currentPrice: string;
  fulfillmentPriceTitle: string;
  fulfillmentPriceSubtitle: string;
  priceDisclaimer: string;
  fulfillmentInfoTitle: string;
  fulfillmentInfoSubtitle1: string;
  fulfillmentInfoSubtitle2: string;
  okGotIt: string;
  orderIsActiveFor: string;
  total: string;
  acceptOrder: string;
  expectedFees: string;
  maximumPriceDeviation: string;
  upTo: string;
  priceDeviationInfoSubtitle1: string;
  priceDeviationInfoSubtitle2: string;
  priceDeviationTitle: string;
  poweredByBpfs: string;
  poweredByTenant: string;
  sellAmount: string;
};

const AcceptOrderTranslations: AcceptOrderTranslations = {
  areYouSureTradeCancel: 'are_you_sure_trade_cancel_@tenant',
  noDontCancel: 'no_dont_cancel',
  yesGoToPortfolio: 'yes_go_to_portfolio',
  summary: 'summary',
  targetPrice: 'stop_order_target_price',
  showLimitOrderTerms: 'stop_order_terms',
  buyAmount: 'buy_amount',
  currentPrice: 'stop_order_current_price',
  fulfillmentPriceTitle: 'stop_order_fulfillment_price_title',
  fulfillmentPriceSubtitle: 'stop_order_fullfilment_price_subtitle',
  priceDisclaimer: 'offer_fees_description',
  fulfillmentInfoTitle: 'stop_order_note_fulfillment_title',
  fulfillmentInfoSubtitle1: 'stop_order_note_fulfillment_subtitle_1',
  fulfillmentInfoSubtitle2: 'stop_order_note_fulfillment_subtitle_2',
  priceDeviationInfoSubtitle1: 'stop_order_note_deviation_subtitle_1',
  priceDeviationInfoSubtitle2: 'stop_order_note_deviation_subtitle_2',
  okGotIt: 'ok_got_it_button',
  orderIsActiveFor: 'stop_order_keep_selection',
  total: 'total',
  acceptOrder: 'accept_order',
  expectedFees: 'stop_order_expected_fees',
  maximumPriceDeviation: 'stop_order_max_price_deviation_title',
  upTo: 'stop_order_max_price_deviation_subtitle',
  priceDeviationTitle: 'stop_order_note_deviation_title',
  poweredByBpfs: 'powered_by_bpfs',
  poweredByTenant: 'powered_by_@tenant',
  sellAmount: 'sell_amount',
};

export const getAcceptOrderTranslations = (
  transUtil: (param: string) => string,
): AcceptOrderTranslations => {
  return Object.entries(AcceptOrderTranslations).reduce((acc, [key, value]) => {
    acc[key as keyof AcceptOrderTranslations] = transUtil(value);

    return acc;
  }, {} as AcceptOrderTranslations);
};
